module.exports = __webpack_public_path__ + "static/media/DEAC_Logo_labdarugas-b.657ef8e7.png";